<template>
  <form @submit.prevent="createProduct" class="flex flex-wrap py-4">
    <div class="w-full py-2">
      <label class="uppercase font-semibold text-sm">Product Code</label>
      <div class="flex gap-2">
        <input
            v-model="newProduct.product_code"
            class="flex-1 bge-input bge-input-spacing rounded"
            type="text"
            required
            placeholder="Product Code..."
        />
        <button
            type="button"
            :disabled="isGeneratingCode"
            @click="generateCode"
            class="px-3 py-1 bg-blue-200 hover:bg-blue-300 text-secondary border border-blue-400 hover:border-blue-500 rounded disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {{ isGeneratingCode ? 'Generating…' : 'Generate Code' }}
        </button>
      </div>
    </div>
    <div class="w-full py-2">
      <label class="uppercase font-semibold text-sm">Name</label>
      <input
          v-model="newProduct.name"
          class="w-full bge-input bge-input-spacing rounded"
          type="text"
          required
          placeholder="Product Name..."
      />
    </div>
    <div class="w-full py-2">
      <label class="uppercase font-semibold text-sm">Description</label>
      <textarea
          v-model="newProduct.description"
          placeholder="Product Description..."
          class="w-full bge-input bge-input-spacing rounded"
          rows="5"
      ></textarea>
    </div>
    <div class="w-full">
      <button
          type="button"
          @click="createProduct"
          class="float-right mt-5 flex items-center bg-green-200 hover:bg-green-300 text-secondary py-1 px-3 rounded border border-green-400 hover:border-green-500 text-secondary hover:shadow active:shadow-inner transition duration-100"
      >
        <svg
            class="stroke-current h-5 w-5 mr-2"
            fill="none"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            viewBox="0 0 24 24"
        >
          <path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z" />
          <path d="M17 21v-8H7v8M7 3v5h8" />
        </svg>
        <span>Create Product</span>
      </button>
    </div>
  </form>
</template>

<script>
import notificationMixin from "@/mixins/notificationMixin";

export default {
  mixins: [notificationMixin],
  data() {
    return {
      newProduct: {
        product_code: "",
        name: "",
        description: "",
      },
      isGeneratingCode: false,
    };
  },
  methods: {
    async generateCode() {
      if (this.isGeneratingCode) return;
      const ok = await this.confirmAction({
        header: "Generate a new product code?",
        message: "This will reserve the next code now. If you do not save the product, that code will still be skipped.",
        acceptLabel: "Yes, generate",
        rejectLabel: "Cancel",
      });
      if (!ok) return;
      this.isGeneratingCode = true;
      try {
        const result = await this.ProductServiceV2.generateProductCode();
        if (result && result.product_code) {
          this.newProduct.product_code = result.product_code;
        }
      } catch (err) {
        console.error("Could not generate product code:", err);
        this.notifyError("Could not generate a product code. Try again or type one.");
      } finally {
        this.isGeneratingCode = false;
      }
    },
    async createProduct() {
      try {
        const code = (this.newProduct.product_code || "").trim();
        if (!code) {
          this.notifyError("Product Code is required.");
          return;
        }
        if (!/^B\d{5}$/.test(code)) {
          this.notifyError("Product Code must be in the format B00000 (uppercase B followed by 5 digits).");
          return;
        }
        if (!this.newProduct.name) {
          this.notifyError("Product Name is required.");
          return;
        }

        const createdProduct = await this.ProductServiceV2.createProduct({
          ...this.newProduct,
          product_code: code,
        });

        this.notifySuccess("Product created successfully.");
        await this.$router.push({
          name: "product-edit",
          params: { productCode: createdProduct.product_code },
        });
      } catch (err) {
        console.error("Error creating product:", err);

        const backendMessage = err && err.data && err.data.message;
        if (backendMessage && typeof backendMessage === "string") {
          this.notifyError(backendMessage);
          return;
        }

        this.notifyError("Failed to create product.");
      }
    }

  },
};
</script>
